const defaultSourceEmail = 'Here4U-No-Reply<hello@here4u.care>';
const defaultDestinationEmail = 'hello@here4u.care';

const dev =  {
    sourceEmail: defaultSourceEmail,
    destinationEmail: defaultDestinationEmail,    
    messagesApi: {
      REGION: "us-west-2",
      API: "messages-api",
      URL: "https://jaa7npite0.execute-api.us-west-2.amazonaws.com/LIVE2",
      PATH: "/email"
    },
    app: {
      version: "x.x.x.x"
    },
    //google analytics for non-prod (dummy values)
    analytics: {
      ga_id: "xx-123456789-0",
      isdebug: true,
      userId: "at23",
      stage: "DEV" //optional
    }
  };
  
const prod =  {
    sourceEmail: defaultSourceEmail,
    destinationEmail: defaultDestinationEmail,
    messagesApi: {
      REGION: "us-west-2",
      API: "messages-api",
      URL: "https://jaa7npite0.execute-api.us-west-2.amazonaws.com/LIVE2",
      PATH: "/email"
    },
    app: {
      version: "0.0.0.0"
    },
    analytics: {
      ga_id: "G-4V4J5X4CEB", //obtain id after creating an account on GA site.
      isdebug: false,
      userId: "here4uv2",
      stage: "" //optional
    }
};
  
// Default to dev if not set
const config = process.env.REACT_APP_STAGE === 'prod'
  ? prod
  : dev;

const configObject = {
  // Add common config values here
  ...config
};

export default configObject;
  